import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=0bab6223"
import script from "./overview.vue?vue&type=script&setup=true&lang=js"
export * from "./overview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports